import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { RecommendationsModuleWrapper } from '../similar-hotels/recommendations-module-wrapper';
export const SUVRCarousel = () => React.createElement(EGDSSpacing, {
  border: ['blockstart', 'blockend'],
  padding: {
    block: 'six',
    small: {
      block: 'three'
    }
  }
}, React.createElement("div", {
  "data-stid": "suvr-carousel"
}, React.createElement(RecommendationsModuleWrapper, null)));